import { RefObject, useCallback, useEffect } from 'react';
import { bigQuery } from '@fiverr-private/obs';
import { useEnteredView } from '@fiverr-private/hooks';
import { EventActionType, EventGroup, getBiEvent } from '../../bi';
import { PortfolioWidgetFullData } from '../../server';
import { usePortfolioWidgetContext } from './PortfolioWidgetContext';

export const useBiComponentExists = (widgetData?: PortfolioWidgetFullData) => {
    const { biEnrichment } = usePortfolioWidgetContext();

    useEffect(() => {
        if (widgetData && widgetData.projects.length > 0) {
            bigQuery.send(
                getBiEvent({
                    type: 'seller_portfolio_component_exists',
                    group: EventGroup.PageView,
                    actionType: EventActionType.Impression,
                    biEnrichment: biEnrichment.current,
                })
            );
        }
    }, [widgetData, biEnrichment]);
};

export const useBiComponentEnteredView = (componentRef: RefObject<HTMLElement>) => {
    const { biEnrichment } = usePortfolioWidgetContext();

    useEnteredView(componentRef, {
        threshold: 1,
        onEntered: () => {
            bigQuery.send(
                getBiEvent({
                    type: 'seller_portfolio_component_is_shown',
                    group: EventGroup.UserImpression,
                    actionType: EventActionType.Impression,
                    biEnrichment: biEnrichment.current,
                })
            );
        },
    });
};

export const useBiClickOnThumbnail = () => {
    const { biEnrichment } = usePortfolioWidgetContext();

    return useCallback(
        ({ projectId, projectSource }) => {
            bigQuery.send(
                getBiEvent({
                    type: 'portfolio_thumbnail_clicked',
                    group: EventGroup.UserAction,
                    actionType: EventActionType.Click,
                    biEnrichment: biEnrichment.current,
                    projectSource,
                    projectId,
                })
            );
        },
        [biEnrichment]
    );
};

export const useBiClickOnSeeAll = () => {
    const { biEnrichment } = usePortfolioWidgetContext();

    return useCallback(() => {
        bigQuery.send(
            getBiEvent({
                type: 'clicked_on_view_see_projects',
                group: EventGroup.UserAction,
                actionType: EventActionType.Click,
                biEnrichment: biEnrichment.current,
            })
        );
    }, [biEnrichment]);
};
